import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ABrighterViewForYourHome from "./sections/ABrighterViewForYourHome";
import Our3StepSimpleProcess from "./sections/Our3StepSimpleProcess";
import WhySellersChooseDhtproperties from "./sections/WhySellersChooseDhtproperties";
import ClaimYourAssessment from "./sections/ClaimYourAssessment";
import HomeownerSuccessStories from "./sections/HomeownerSuccessStories";
import CommonInquiries from "./sections/CommonInquiries";
import CorporateFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ABrighterViewForYourHome />
      <Our3StepSimpleProcess />
      <WhySellersChooseDhtproperties />
      <ClaimYourAssessment />
      <HomeownerSuccessStories />
      <CommonInquiries />
      <CorporateFooter />
    </div>;
}